"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runInterceptors = void 0;
const runInterceptors = ({ source, interceptors }) => {
    let interceptedSource = source;
    if (interceptors) {
        interceptors.forEach((interceptor) => {
            interceptedSource = interceptor(interceptedSource);
        });
    }
    return interceptedSource;
};
exports.runInterceptors = runInterceptors;
